import { render, staticRenderFns } from "./createInbound.vue?vue&type=template&id=5dc1fc32&scoped=true&"
import script from "./createInbound.vue?vue&type=script&lang=js&"
export * from "./createInbound.vue?vue&type=script&lang=js&"
import style0 from "./createInbound.vue?vue&type=style&index=0&id=5dc1fc32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc1fc32",
  null
  
)

export default component.exports